module.exports = __webpack_public_path__ + "img/003-washing-machine.89f5bba5.png";